// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginPopup_root__F2IaY","body":"LoginPopup_body__nUuKZ"};